import { Button, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import React from 'react';

import { ProgramManagementListItem } from './programs.types';

interface Props {
    deletingProgramName?: string;
    items: ProgramManagementListItem[];
    onDelete: (name: string) => void;
    onEdit: (name: string) => void;
    onOpen: (name: string) => void;
    onProcess: (name: string) => void;
    processingProgram: boolean;
    processingProgramName?: string;
}

const ProgramListTable: React.FC<Props> = ({ deletingProgramName, items, onDelete, onEdit, onOpen, onProcess, processingProgram, processingProgramName }) => (
    <TableContainer component={Paper} sx={{ borderRadius: 3 }} variant="outlined">
        <Table>
            <TableHead>
                <TableRow>
                    <TableCell>Program Name</TableCell>
                    <TableCell>Weeks</TableCell>
                    <TableCell>Configured Days</TableCell>
                    <TableCell>Status</TableCell>
                    <TableCell align="right">Actions</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {items.map((item) => {
                    const isProcessingThisProgram = processingProgram && processingProgramName === item.name;

                    return (
                    <TableRow hover key={item.name}>
                        <TableCell>
                            <strong>{item.displayName}</strong>
                            <div>{item.name}</div>
                        </TableCell>
                        <TableCell>{item.totalWeeks}</TableCell>
                        <TableCell>{item.totalDays} / {item.totalWeeks * 7}</TableCell>
                        <TableCell>{item.status} {item.live ? '• Live' : '• Draft'}</TableCell>
                        <TableCell align="right">
                            <Button onClick={() => onOpen(item.name)} size="small">Open</Button>
                            <Button onClick={() => onEdit(item.name)} size="small">Edit</Button>
                            <Button disabled={processingProgram} onClick={() => onProcess(item.name)} size="small">
                                {isProcessingThisProgram ? 'Processing...' : 'Process'}
                            </Button>
                            <Button color="error" disabled={deletingProgramName === item.name} onClick={() => onDelete(item.name)} size="small">Delete</Button>
                        </TableCell>
                    </TableRow>
                    );
                })}
            </TableBody>
        </Table>
    </TableContainer>
);

export default ProgramListTable;